import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const line = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: "0%",
    transition: { duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.3 + i * 0.14 },
  }),
};

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden bg-brand-forest">
      {/* Parallax background image */}
      <motion.div
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0"
      >
        <img
          src="/images/araucaria/1.avif"
          alt="Chalé de luxo no Recanto dos Pinheiros"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-forest via-brand-forest/40 to-brand-forest/60" />
      </motion.div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12 min-h-screen flex flex-col justify-end pb-20 pt-32">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="text-[12px] md:text-sm uppercase tracking-[0.35em] font-bold text-brand-cream/90 mb-6"
          data-testid="hero-eyebrow"
        >
          Chalés de luxo · Atibaia · São Paulo
        </motion.p>

        <h1
          data-testid="hero-title"
          className="text-brand-cream font-bold tracking-tighter uppercase leading-[0.88] text-5xl md:text-7xl lg:text-[8vw]"
        >
          <span className="reveal-mask">
            <motion.span custom={0} variants={line} initial="hidden" animate="visible" className="block">
              Refúgio na
            </motion.span>
          </span>
          <span className="reveal-mask">
            <motion.span custom={1} variants={line} initial="hidden" animate="visible" className="block text-brand-terracotta">
              natureza
            </motion.span>
          </span>
          <span className="reveal-mask">
            <motion.span custom={2} variants={line} initial="hidden" animate="visible" className="block">
              de Atibaia
            </motion.span>
          </span>
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.9, duration: 0.9 }}
          className="mt-10 flex flex-col md:flex-row md:items-end md:justify-between gap-8"
        >
          <p className="max-w-xl text-brand-cream/85 text-base md:text-lg leading-relaxed">
            A apenas 60 km da capital paulista, um verdadeiro refúgio de paz, ar puro e
            uma vista inesquecível da Pedra Grande. Piscinas de borda infinita, ofurô com
            cromoterapia e a floresta ao seu redor.
          </p>

          <div className="flex flex-wrap gap-4">
            <button
              data-testid="hero-cta-reservar"
              onClick={() => scrollTo("#reservar")}
              className="group relative overflow-hidden bg-brand-terracotta text-brand-cream px-9 py-4 text-[13px] uppercase tracking-[0.2em] font-bold"
            >
              <span className="relative z-10">Reservar agora</span>
              <span className="absolute inset-0 bg-brand-terracotta-hover translate-y-full group-hover:translate-y-0 transition-transform duration-400" />
            </button>
            <button
              data-testid="hero-cta-chales"
              onClick={() => scrollTo("#chales")}
              className="group border border-brand-cream/60 text-brand-cream px-9 py-4 text-[13px] uppercase tracking-[0.2em] font-bold hover:bg-brand-cream hover:text-brand-forest transition-colors duration-400"
            >
              Ver chalés
            </button>
          </div>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 10, 0] }}
        transition={{ opacity: { delay: 1.4 }, y: { repeat: Infinity, duration: 2 } }}
        className="absolute bottom-8 right-6 md:right-12 z-10 text-brand-cream/70"
      >
        <ArrowDown className="w-5 h-5" />
      </motion.div>
    </section>
  );
};
